import { Bet } from "interfaces/bet";
import ShareButtons from "components/bet-details-page/share-buttons";
import { Link } from "react-router-dom";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import { useAppSelector } from "state/hooks";
import { getGroupStyles } from "state/slices/group-slice";
import { ContestEntry, remainingPicksForEntry } from "interfaces/leaderboard/contest";
import { CONTEST_ENTRY_STATUS } from "utils/constants";

interface Props {
  bet: Bet;
  contestEntry?: ContestEntry;
  totalPicksMade?: number;
  isBasic?: boolean;
  isPickPerPool?: boolean;
}

const SecondaryColorHeavierBlock = ({ children }: { children: React.ReactNode }) => {
  const secondaryColor = useAppSelector(getGroupStyles).secondary_color;
  return (
    <span style={{ color: secondaryColor, fontSize: "1.2em" }}>
    {children}
  </span>
  );
};

interface MessageTextProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const MessageText = ({ children, style }: MessageTextProps) => (
  <BlockyMediumText style={{ color: "white", ...style }}>
    {children}
  </BlockyMediumText>
);

const Content = ({ bet, contestEntry, totalPicksMade, isBasic, isPickPerPool }: Props) => {
  const atLeast = isBasic ? "" : "at least ";
  const isEntryValid = contestEntry?.status === CONTEST_ENTRY_STATUS.VALID;
  const isOptionalPick = !!contestEntry && isEntryValid
    && totalPicksMade !== undefined
    && totalPicksMade > contestEntry.unique_contestants_required;

  const shouldShowProgress = !!contestEntry;
  const required = contestEntry?.unique_contestants_required ?? 0;
  const picked = contestEntry?.unique_contestants_picked ?? 0;
  const remaining = remainingPicksForEntry(contestEntry);

  return (
    <div data-testid={"successful-bet-modal-content"}>
      {shouldShowProgress && !isOptionalPick && (
        <div style={{ marginBottom: "20px", textAlign: "center" }}>
          {isEntryValid ? (
            <>
              <MessageText>
                You've made {isBasic ? "" : "at least "}
                <SecondaryColorHeavierBlock>{required} picks</SecondaryColorHeavierBlock> and
                your entry
                is <SecondaryColorHeavierBlock>valid</SecondaryColorHeavierBlock>.
              </MessageText>
              {!isBasic && (
                <MessageText style={{ marginTop: "10px" }}>
                  If you have remaining balance, you may make more picks during the contest
                </MessageText>
              )}
            </>
          ) : (
            <>
              <MessageText>
                You've
                made <SecondaryColorHeavierBlock>{picked} of {required} picks</SecondaryColorHeavierBlock> in
                this contest
              </MessageText>
              <MessageText style={{ marginTop: "10px" }}>
                Make {atLeast}
                <SecondaryColorHeavierBlock>{remaining} more</SecondaryColorHeavierBlock> {remaining > 1 ? "picks" : "pick"}{" "}
                {isPickPerPool ? "on different pools" : "with different contestants"} to complete your entry!
              </MessageText>
            </>
          )}
        </div>
      )}
      <BlockyMediumText
        style={{ color: "white", display: "flex", justifyContent: "center" }}
      >
        Click&nbsp;<Link to={`/bets/${bet.id}`}>here</Link>&nbsp;to view details
        about your pick.
      </BlockyMediumText>
      {(!shouldShowProgress || isEntryValid) && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
          <ShareButtons bet={bet} />
        </div>
      )}
    </div>
  );
};

export default Content;
